<template>
    <div class="modal fade" id="createTaskModal" role="dialog" aria-labelledby="updateUsergroupModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="updateUsergroupModalLabel">{{$t('buttons.usergroupEdit.btnText')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <role-edit-card v-model="model"
                                      v-if="showEditor"
                                      :create="false"
                                      @save="onRoleEdit"
                                      @cancel="onCancel">
                    </role-edit-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Role } from '../../../models/models';
    import RoleEditCard from './AspNetRoleEditCard';

    export default {
        components: {
            RoleEditCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showEditor: false,
                model: new Role(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new Role();
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onRoleEdit(model) {
                this.$emit('onEdit', model);
                this.onClose();
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            //add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            //remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new Role(this.value);
                    this.showEditor = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
